import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { PoModule } from '@po-ui/ng-components';

@Component({
  standalone: true,
  imports: [
    PoModule
  ],
  selector: 'app-blocked',
  templateUrl: './blocked.component.html',
  styleUrls: ['./blocked.component.css']
})
export class BlockedComponent {

  constructor(
    private router: Router
  ) { 

  }

  // blockedImage: string = 'assets/images/big-lock.svg';
  blockedImage: string = 'assets/closed.png';

  public buttonClick(): void {
    this.router.navigate(['/home']);
  }

}
